import { ForumsPanel } from "@/components/ForumsPanel";
export default function CoachForums() { return <ForumsPanel testid="coach-forums" spaceToggle />; }
